//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import { BFormSelect, BFormSelectOption } from 'bootstrap-vue'


export default {

    name: 'PartialContactEntries',

    mixins: [ProfileData],

    components: { BFormSelect, BFormSelectOption },

    props: {
        company: {
        },
    },

    data() {
        return {
            showEntriesInit: 8,
            contactsShowed: 0,
            contactSelected: 'all',
        }
    },

    mounted() {
        this.contactsShowed = this.showEntriesInit - 1
    },

    methods: {

        getNoFollowEntry(destination) {

            if(this.company.isMasterProfile) {
                return false
            }

            if(destination.noFollow) {
                return 'nofollow'
            } else {
                return false
            }
        },

        loadMoreContacts() {
            this.contactsShowed += this.showEntriesInit
        },

        showContactEntry(index, id) {

            if(this.contactSelected === 'all') {

                if(index <= this.contactsShowed) {
                    return true
                }

                return false
            }

            if(this.contactSelected === id) {
                return true
            }

            return false

        },

    },

    computed: {

        destinations() {
            return this.$store.state.profile.destinations
        },

        contactSelectData() {
            return this.$store.state.profile.contactSelectData
        },

        contactSelectDataLength() {
            return this.contactSelectData.length
        },

        showSelectData() {
            return this.contactSelectDataLength > this.showEntriesInit
        },

        showLoadMore() {

            if(this.contactSelected !== 'all') {
                return false
            }

            let length = this.contactSelectDataLength

            if(length <= this.showEntriesInit) {
                return false
            }

            let showed = this.contactsShowed + 1

            if(showed >= length) {
                return false
            }

            return true
        },

        contactEntries() {

            let entries = []

            this.destinations.forEach(destination => {

                if(destination.hasOffices) {

                    destination.offices.forEach(office => {

                        entries.push({
                            isOffice: true,
                            key: 'office-'+office.id,
                            id: 'office-' + office.id,
                            countryName: destination.countryName,
                            locality: office.locality,
                            email: office.email,
                            companyProfileId: destination.companyProfileId,
                            destinationId: destination.id,
                            phoneEncode: office.phoneEncode,
                            phoneDisplay: office.phoneDisplay,
                            website: office.website,
                            fixedWebsiteUrl: office.fixedWebsiteUrl,
                            websiteDisplay: office.websiteDisplay,
                            noFollow: this.getNoFollowEntry(destination),

                        })

                    })

                } else {

                    if(destination.useCompanyContact == 0) {

                        entries.push({
                            isOffice: false,
                            useCompanyContact: destination.useCompanyContact,
                            key: 'dest-contact-' + destination.id,
                            id: 'dest-' +  destination.id,
                            countryName: destination.countryName,
                            locality: destination.locality,
                            email: destination.email,
                            companyProfileId: destination.companyProfileId,
                            destinationId: destination.id,
                            phoneEncode: destination.phoneEncode,
                            phoneDisplay: destination.phoneDisplay,
                            fixedWebsiteUrl: destination.fixedWebsiteUrl,
                            websiteDisplay: destination.websiteDisplay,
                            noFollow: this.getNoFollowEntry(destination),

                        })

                    } else {

                        entries.push({
                            isOffice: false,
                            useCompanyContact: destination.useCompanyContact,
                            key: 'dest-contact-' + destination.id,
                            id: 'dest-' +  destination.id,
                            countryName: destination.countryName,
                            locality: destination.locality,
                            email: this.company.email,
                            companyProfileId: destination.companyProfileId,
                            destinationId: destination.id,
                            phoneEncode: this.company.phoneEncode,
                            phoneDisplay: this.company.phoneDisplay,
                            fixedWebsiteUrl: this.company.fixedWebsiteUrl,
                            websiteDisplay: this.company.websiteDisplay,
                            noFollow: this.getNoFollowEntry(destination),

                        })

                    }

                }

            })

            return entries

        },

    }

}

